import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatErr, setAuthToken } from "@/lib/api";
import { Login } from "@/components/admin/Login";
import { Inquiries } from "@/components/admin/Inquiries";
import { Reviews } from "@/components/admin/Reviews";
import { ContentEditor } from "@/components/admin/ContentEditor";
import { Discounts } from "@/components/admin/Discounts";
import { Settings } from "@/components/admin/Settings";

const TABS = [["inq", "Zapytania"], ["reviews", "Opinie"], ["discounts", "Kody rabatowe"], ["content", "Treść strony"], ["settings", "Ustawienia"]];

export default function Admin() {
  const [user, setUser] = useState(null);
  const [tab, setTab] = useState("inq");

  useEffect(() => {
    api.get("/auth/me").then(({ data }) => setUser(data)).catch(() => setUser(false));
  }, []);

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { toast.error(formatErr(e)); }
    setAuthToken(null);
    setUser(false);
  };

  if (user === null) return <div className="loading-screen">amore<i>moment</i></div>;
  if (!user) return <div className="wrap adm"><Login onLogin={setUser} /></div>;

  return (
    <div className="wrap adm" data-testid="admin-dashboard">
      <div className="adm-top">
        <a className="logo" href="/" data-testid="admin-view-site-link">amore<i>moment</i> <span className="label" style={{ marginLeft: 10 }}>panel</span></a>
        <div className="tabs">
          {TABS.map(([k, t]) => <button key={k} className={`tab${tab === k ? " on" : ""}`} onClick={() => setTab(k)} data-testid={`admin-tab-${k}`}>{t}</button>)}
          <a className="tab" href="/" target="_blank" rel="noreferrer">Podgląd strony ↗</a>
          <button className="tab" onClick={logout} data-testid="admin-logout-btn">Wyloguj</button>
        </div>
      </div>
      {window.location.hostname.includes("preview.emergentagent.com") && (
        <p className="preview-note" data-testid="admin-preview-note">
          To jest <b>wersja podglądowa</b>. Ma osobną bazę danych, więc zmiany zrobione tutaj nie pojawią się na opublikowanej stronie. Zdjęcia i treści dla klientów dodawaj w panelu opublikowanej strony (adres strony + /admin).
        </p>
      )}
      {tab === "inq" && <Inquiries />}
      {tab === "reviews" && <Reviews />}
      {tab === "discounts" && <Discounts />}
      {tab === "content" && <ContentEditor />}
      {tab === "settings" && <Settings user={user} />}
    </div>
  );
}
